import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";

@Injectable({
  providedIn: "root"
})
export class PageTitleService {

  constructor(
    protected readonly _titleService: Title
  ) { }

  /**
   * Set a new page title
   */
  public setTitle(title: string): void {
    this._titleService.setTitle(!title ? "Empirica" : `${title} | Empirica`);
  }
}
